import { useState } from "react";
import "../../InputDropdown/InputDropdown.scss";
import InputMultiselectItem from "./InputMultiselectItem";

const InputMultiSelect = ({ dropdowndata, inputcontent, SelectedItems }) => {
  const [selectedOption, setSelectedOption] = useState(-1);
  const [data, setData] = useState(dropdowndata);

  const [SelectedData, setSelectedData] = useState(SelectedItems);

  const OnSelect = (event) => {
    let name = event.target.name;
    let checked = event.target.checked;
    if (!SelectedData?.includes(name) && checked) {
      let arr = SelectedData ? [...SelectedData] : [];
      arr.push(name);
      setSelectedData(arr);
      inputcontent(arr);
    } else {
      let updatedData = SelectedData?.filter((el) => {
        return name !== el;
      });
      inputcontent(updatedData);
      setSelectedData(updatedData);
    }
  };

  return (
    <div className={`Inputdropdown `}>
      {data?.map((e, i) => {
        return (
          <div
            key={i}
            className={i === selectedOption ? `selectDropdown forHover` : "selectDropdown"}
            onClick={() => {
             
                OnSelect({ target: { name: e, checked: true } });
             
            }}
          >
            <InputMultiselectItem text={e} OnSelect={OnSelect} SelectedData={SelectedData} />
          </div>
        );
      })}
    </div>
  );
};

export default InputMultiSelect;
